import React, { useContext, useEffect, useMemo, useState } from "react";
import { Label, Pivot, PivotItem, Spinner, SpinnerSize } from "@fluentui/react";
import studyviewerContext from "../../context/studyviewer/StudyviewerContext";
import Toast from "../../components/Toast/Toast";
import "./styles/styles.css";
import AlertSubmitSection from "./components/RaiseAlertSection/AlertSubmitSection";
import RadioDropdownSection from "./components/RadioDropdownSection/RadioDropdownSection";
import CustomTabs from "./components/Tabs";
import EditorSection from "./components/EditorSection/EditorSection";
import studyReportContext from "../../context/studyreport/StudyReportContext";
import { config, circlStyle } from "./helper/initialData";
import FroalaEditor from 'react-froala-wysiwyg';
import Froalaeditor from 'froala-editor'
import LockWarning from "./components/LockWarning/LockWarning";
import AddTab from "./components/AddTab/AddTab";
import CustomEditor from "./components/CustomEditorSection/CustomEditor";
import RSNAModal from "./components/ReportModals/RSNAModal/RSNAModal";
import HrctChestILDModal from "./components/ReportModals/HrctChestILDModal/HrctChestILDModal";
import CTBrainModal from "./components/ReportModals/CTBrainModal/CTBrainModal";
import HrctChestCovid from "./components/ReportModals/HRCTChestCovid/HrctChestCovid";
import ReturnStudyModal from "../StudyViewer/Components/ReturnStudyModal/ReturnStudyModal";
import CustomCKEditor from "./components/CustomEditorSection/CustomCKEditor";
import userContext from "../../context/users/UserContext";
import MRISpine from "./components/ReportModals/MRSpine/MRISpine";
import AddendumDisclaimerModal from "./components/ReportModals/DisclaimerModal/AddendumDisclaimerModal";
import SubmitTick from "../StudyViewer/Components/SubmitTick/SubmitTick";
import StudyExpirationPopup from "../StudyViewer/Components/Unassignment/StudyExpirationPopup";
import StudyExpirationTimer from "../StudyViewer/Components/Unassignment/StudyExpirationTimer";
import ForceReinference from "./components/ReportModals/ForceReinference/ForceReinference";
import ChatInput from "./components/ChatInput/ChatInput";
import InstructionStack from "./components/InstructionStack/InstructionStack";
import FormatterAgentClippedModal from "../StudyList/components/Modal/FormatterAgent/FormatterAgentStudyClippedModal";
import { NONXRAYMODALITIES } from "../../constants/Constants";
import { isChestXrayOrCtBrainStudy } from "../../service/MaskImageService";
const NewReport = (props) => {

  const { userPrompts, setUserPrompts } = useContext(studyReportContext);
  // Function to handle new prompts from chat input
  const handleNewPrompt = (prompt, isNote) => {
    // Add new prompt to the beginning of the array (reverse chronological order)
    const newObject = { prompt: prompt, isNote: isNote }
    setUserPrompts(prevPrompts => [newObject, ...prevPrompts]);
  };

  const {
    showToast,
    openRSNAModal,
    RSNAModalContent,
    setOpenRSNAModal,
    setReportModalState,
    reportModalState,
    currentActiveTab,
    regenerateClick,
    regenerateHRCT,
    showReturnStudyModal,
    setShowReturnStudyModal,
    showAddendumDisclaimerModal,
    setShowAddendumDisclaimerModal,
    showConfirmModal,
    setShowConfirmModal,
    isChildStudyReportState, setIsChildStudyReportState,
    handleUpdateReportSection,
    allReportTemplatesLoading,
    setFirmId,
    showForceReinferenceModal,
    templateHeight,
    isExternal,
    showFormatterPopupClipped,
    studyDescription
  } = useContext(studyReportContext);

  const {
    editorName,
    authenticated,
    loadByUsername,
    enableLlmReport
  } = useContext(userContext);



  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
    }
  }, []);

  const hideModal = () => {
    // console.log("hiding");
    setOpenRSNAModal(false);
  }

  const hideModalCT = () => {
    setReportModalState(() => {
      const newVal = { ...reportModalState };
      newVal.hrctChestILD = false;
      newVal.hrctChestCovid = false;
      newVal.ctBrain = false;
      newVal.mriSpine = false;
      newVal.content = {};
      return newVal;
    });
  }

  const hideModalCTBrain = () => {
    setReportModalState(() => {
      const newVal = { ...reportModalState };
      newVal.hrctChestILD = false;
      newVal.hrctChestCovid = false;
      newVal.ctBrain = false;
      newVal.content = {};
      return newVal;
    });
  }

  const regenerateRSNA = (reportName) => {
    hideModal();
    if (reportName == "TUBERCULOSIS") {
      regenerateClick();
    }
  }

  const regenerateHRCTFunc = (reportName) => {
    // console.log("Console log"+reportModalState.content);

    hideModalCT();
    regenerateHRCT(reportModalState.content);
  }

  const toggleEditorFunc = () => {
    // setToggleEditor((prev) => !prev);
  }

  useEffect(() => {
    if (!props.isStudyList && props.activeStudyId != null && props.studyParentId != null) {
      // console.log("--- Active Study Id ---",props.activeStudyId);
      if (props.activeStudyId == props.studyParentId) {
        setIsChildStudyReportState(false);
      } else {
        setIsChildStudyReportState(true);
        handleUpdateReportSection(props.parentChildReportsObj, props.activeStudyId);
      }

    }
  }, [props.activeStudyId]);



  const checkForParentOrChild = () => {
    if (props.activeStudyId == null || props.studyParentId == null) {
      return false;
    }
    return props.activeStudyId != props.studyParentId;
  }

  const customSpinnerStyle = {
    root: {
      height: "100px"
    },
    circle: {
      height: "50px",
      width: "50px",
      borderWidth: "3px",
    },
  };

  return (
    <>
      <div className="w100 h100"
        style={{
          ...(enableLlmReport  && isChestXrayOrCtBrainStudy(props.modality, studyDescription )&& {
            overflow: 'hidden',
            position: 'relative',
            boxSizing: 'border-box'
          }),
        }}
      >
        {/* <div className="spinner-place">
        {showToast.loading &&  <Spinner size={SpinnerSize.large} styles={circlStyle}/>}
        </div> */}

        {(props.showStudyExpirationPopup || props.showStudyAlreadyExpiredPopup) && (
          <StudyExpirationPopup
            setShowReturnStudyModal={setShowReturnStudyModal}
          />
        )}
        {reportModalState.hrctChestILD && (
          <HrctChestILDModal
            regenerateClick={regenerateHRCTFunc}
            hideModal={hideModalCT}
            id={reportModalState.id}
            content={reportModalState.content}
            isModalOpen={reportModalState.hrctChestILD}
          />
        )}
        {reportModalState.ctBrain && (
          <CTBrainModal
            regenerateClick={regenerateHRCTFunc}
            hideModal={hideModalCTBrain}
            id={reportModalState.id}
            content={reportModalState.content}
            isModalOpen={reportModalState.ctBrain}
          />
        )}
        {reportModalState.hrctChestCovid && (
          <HrctChestCovid
            regenerateClick={regenerateHRCTFunc}
            hideModal={hideModalCTBrain}
            id={reportModalState.id}
            content={reportModalState.content}
            isModalOpen={reportModalState.hrctChestCovid}
          />
        )}
        {reportModalState.mriSpine && (
          <MRISpine
            regenerateClick={regenerateHRCTFunc}
            hideModal={hideModalCT}
            id={reportModalState.id}
            content={reportModalState.content}
            isModalOpen={reportModalState.mriSpine}
          />
        )}

        {/* {showToast.show && <Toast state={showToast.state} text={showToast.message} />} */}
        {showReturnStudyModal && (
          <ReturnStudyModal
            setShowReturnStudyModal={setShowReturnStudyModal}
            showReturnStudyModal={showReturnStudyModal}
          />
        )}
        {showForceReinferenceModal && (
          <ForceReinference
            keyImages={props.keyImages}
            annotationData={props.annotationData}
            annotationDataAI={props.annotationDataAI}
            allTextToolAnnotation={props.allTextToolAnnotation}
            activeViewportIndex={props.activeViewportIndex}
          />

        )}
        {showAddendumDisclaimerModal && showConfirmModal && (
          <AddendumDisclaimerModal
            keyImages={props.keyImages}
            annotationData={props.annotationData}
            annotationDataAI={props.annotationDataAI}
            allTextToolAnnotation={props.allTextToolAnnotation}
            activeViewportIndex={props.activeViewportIndex}
          />
        )}

        {enableLlmReport &&isChestXrayOrCtBrainStudy(props.modality, studyDescription ) && 
          <AlertSubmitSection
            qcData={props.qcData}
            isStudyList={props.isStudyList}
            keyImages={props.keyImages}
            annotationData={props.annotationData}
            annotationDataAI={props.annotationDataAI}
            activeViewportIndex={props.activeViewportIndex}
            allTextToolAnnotation={props.allTextToolAnnotation}
            patientName={props.patientName}
            patientId={props.patientId}
            modality={props.modality}
            extReportReived={props.extReportReived}
          />
        }

        <div
          className="report-container"
          style={{
            // maxHeight: props.isStudyList ? "58vh" : "unset",
            overflow: enableLlmReport &&isChestXrayOrCtBrainStudy(props.modality, studyDescription ) ? "visible" : props.isStudyList ? "auto" : "unset",
            position: "relative",
          }}
        >
          {
            <div
              style={{
                position: "absolute",
                height: "100%",
                width: "100%",
                zIndex: 1000,
                justifyContent: "center",
                alignItems: "center",
                display: allReportTemplatesLoading ? "flex" : "none"
              }}
            >
              <Spinner size={SpinnerSize.small} styles={customSpinnerStyle} label="Loading..." />
            </div>
          }
          <div className="report-container"
            style={{ filter: allReportTemplatesLoading ? "blur(2px)" : "unset" }}
          >
            <div
              style={{
                borderBottom: "1px solid #A5A5A5",
                display: "flex",
                flexDirection: "column",
                //height: "70px",
                boxSizing: "border-box"
              }}
            >
              {!(enableLlmReport && isChestXrayOrCtBrainStudy(props.modality, studyDescription )) && (
                <>
                  <LockWarning
                    assignmentData={
                      props.assignmentData != undefined ? props.assignmentData : null
                    }
                    isStudyList={props.isStudyList}
                  />
                  <RadioDropdownSection />
                  <AddTab isStudyList={props.isStudyList} isChild={props.isStudyList ? false : checkForParentOrChild()} />
                </>
              )}
            </div>
            <div
              style={{
                ...(!(enableLlmReport && isChestXrayOrCtBrainStudy(props.modality, studyDescription )) && { borderBottom: "1px solid #A5A5A5" }),
                paddingBottom: "5px",
                height: `${isExternal ? "402px" : `calc(100% - ${(enableLlmReport && isChestXrayOrCtBrainStudy(props.modality, studyDescription) ? 152 : 106 + templateHeight)}px)`}`,
                boxSizing: "border-box",
                ...(!(enableLlmReport && isChestXrayOrCtBrainStudy(props.modality, studyDescription )) && { paddingLeft: "22px" })
              }}
            >
              {editorName != "" && editorName == "ckeditor" ? (
                <CustomCKEditor
                  modality={props.modality}
                  showPathologyOptions={props.showPathologyOptions}
                  customHeight={props.customHeight}
                />
              ) : (
                <CustomEditor
                  modality={props.modality}
                  showPathologyOptions={props.showPathologyOptions}
                  customHeight={props.customHeight}
                  isStudyList={props.isStudyList}
                  isChild={props.isStudyList ? false : checkForParentOrChild()}
                />
              )}
            </div>

            {enableLlmReport &&isChestXrayOrCtBrainStudy(props.modality, studyDescription ) && (
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "center",
                  position: 'relative',
                }}>
                  <InstructionStack instructions={userPrompts} />
                  {/* <InstructionStack/> */}
                </div>
                <div style={{
                  display: "flex", justifyContent: "center", width: "100%",
                  position: 'relative',
                  zIndex: 1001, // Higher than instruction-tab's 1000
                  marginTop: 'auto',
                }}>
                  <ChatInput onSendMessage={handleNewPrompt} />
                </div>
              </div>
            )}


            {/* <RadioDropdownSection /> */}
            {/* <CustomTabs /> */}
            {/* <div className="editor-container">
            <EditorSection />
          </div> */}
          {!(enableLlmReport && isChestXrayOrCtBrainStudy(props.modality, studyDescription )) && (
            <AlertSubmitSection
              qcData={props.qcData}
              isStudyList={props.isStudyList}
              keyImages={props.keyImages}
              annotationData={props.annotationData}
              annotationDataAI={props.annotationDataAI}
              activeViewportIndex={props.activeViewportIndex}
              allTextToolAnnotation={props.allTextToolAnnotation}
              patientName={props.patientName}
              patientId={props.patientId}
              modality={props.modality}
              extReportReived={props.extReportReived}

            />
          )}
             {showFormatterPopupClipped &&
            <FormatterAgentClippedModal
            qcData={props.qcData}
            isStudyList={props.isStudyList}
            keyImages={props.keyImages}
            annotationData={props.annotationData}
            annotationDataAI={props.annotationDataAI}
            activeViewportIndex={props.activeViewportIndex}
            allTextToolAnnotation={props.allTextToolAnnotation}
            patientName={props.patientName}
            patientId={props.patientId}
            modality={props.modality}
            extReportReived={props.extReportReived}
            />
            }
          </div>
        </div>
      </div>
    </>
  );

}; 

export default NewReport;

